import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: {},
  authed: false,
  token: null,
};

const tempLoginSlice = createSlice({
  name: 'Templogin',
  initialState,
  reducers: {
    setLoginData: (state, action) => {
      state.value = { ...action.payload };
    },
    setTempAuthed: (state, action) => {
      state.authed = action.payload.authed;
      state.value = action.payload.data;
    },
  },
});

export const { setLoginData, setTempAuthed } = tempLoginSlice.actions;

export default tempLoginSlice.reducer;
